// Pure string/date match helpers for client-side list filtering. These lived as static methods on
// RvSearch (components/Search.tsx), which imports the Semantic-backed RvInput, so importing them
// pulled Semantic UI into every caller. RvSearch's statics now delegate to these.
export const filterString = (value: string, filter: string) => {
    return value && value.toLowerCase().includes(filter);
};

export const filterDate = (value: Date | string, filter: string) => {
    if (!value) {
        return false;
    }
    let dateValue: Date;
    if (typeof value === 'string') {
        dateValue = new Date(Date.parse(value as string));
    } else {
        dateValue = value as Date;
    }
    var textValue = dateValue.toDateString() + ' ' + dateValue.toLocaleTimeString();
    return textValue.toLowerCase().includes(filter);
};
